import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import { useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import Blockquote from '../../../components/Blockquote';
import Button from '../../../components/Button';
import DatePicker from '../../../components/DatePicker';
import GenericCard from '../../../components/GenericCards/GenericCards';
import Pager from '../../../components/Pager';
import Select from '../../../components/Select';
import {
  addOrRemoveDaysToGivenDate,
  DateFormats,
  formatDate,
} from '../../../utils/utils';
import FilterPopover from '../filterPopover/FilterPopover';

const options = [
  { value: 'bonus', label: 'Bonus' },
  { value: 'annual-base-pay', label: 'Annual Base Pay' },
];

const tableData = [
  {
    date: formatDate(
      addOrRemoveDaysToGivenDate(new Date(), -1),
      DateFormats.US
    ),
    type: 'Bonus',
    status: '$7,558.57',
  },

  {
    date: `01/01/${formatDate(
      addOrRemoveDaysToGivenDate(new Date(), -1),
      DateFormats.ONLY_YEAR
    )}`,
    type: 'Annual Base Pay',
    status: '$107,222.22',
  },

  {
    date: formatDate(
      addOrRemoveDaysToGivenDate(new Date(), -731),
      DateFormats.US
    ),
    type: 'Bonus',
    status: '$4,232.96',
  },
];

const popOverBody = (
  <Row>
    <Col className={'col-12 mb-7'}>
      <h2 className={'h6 fw-normal'}>Filters</h2>
    </Col>
    <Col className={'col-12'}>
      <DatePicker
        placeholder={'Select a start date'}
        label={'Select Date Range'}
      />
    </Col>
    <Col className={'col-12 mt-7'}>
      <DatePicker placeholder={'Select an end date'} />
    </Col>
    <Col className={'col-12 mt-7'}>
      <Select label={'Select Pay Type'} options={options} />
    </Col>
  </Row>
);

const PayHistory = () => {
  const [currPage, setCurrPage] = useState(1);

  return (
    <Col className={'px-0 col-12 col-lg-7'}>
      <Row className={'mt-5 mt-lg-10'}>
        <Col className={'col-12'}>
          <Blockquote
            children={
              <span className={'text-fs-6 fw-light text-dark-grey'}>
                This information is being used to calculate your pension
                benefits. If anything is incorrect please contact the call
                center at 1-800-888-8888
              </span>
            }
          />
        </Col>
      </Row>

      <Row className={'mt-10 mt-lg-11'}>
        <Col className={'col-4 col-lg-12 d-flex justify-content-end'}>
          <FilterPopover
            popoverBody={popOverBody}
            children={<Button leftIcon={light('filter')}>{'Filter'}</Button>}
          />
        </Col>
      </Row>

      <GenericCard className={'mt-10 mt-lg-11 p-7 p-lg-10'} variant={'white'}>
        <Row className={'py-7 border-bottom-dark-gray mx-0'}>
          <Col className={'col-4'}>
            <span className={'text-fs-6'}>Date</span>
          </Col>
          <Col className={'col-4'}>
            <span className={'text-fs-6'}>Type</span>
          </Col>
          <Col className={'col-4 text-end'}>
            <span className={'text-fs-6'}>Amount</span>
          </Col>
        </Row>

        {tableData.map((data, idx) => {
          return (
            <Row
              key={idx}
              className={`py-7 ${
                idx !== tableData.length - 1 ? 'border-bottom border-info' : ''
              } mx-0`}
            >
              <Col className={'col-4'}>
                <span className={'text-fs-6 fw-light'}>{data.date}</span>
              </Col>
              <Col className={'col-4'}>
                <span className={'text-fs-6 fw-light'}>{data.type}</span>
              </Col>
              <Col className={'col-4 text-end'}>
                <span className={'text-fs-6 fw-light'}>{data.status}</span>
              </Col>
            </Row>
          );
        })}

        <Row className={'mt-10'}>
          <Col
            className={
              'col-12 d-flex justify-content-center justify-content-lg-start'
            }
          >
            <Pager
              currentPage={currPage}
              onPageChange={setCurrPage}
              pagesSize={3}
            />
          </Col>
        </Row>
      </GenericCard>
    </Col>
  );
};

export default PayHistory;
